import React from "react";
import { useSelector } from "react-redux";
import { Stack, Typography } from "@mui/material";

import { RootState } from "../../store";
import { t } from "../../components/translate";
import ClientSearch from "../../components/ClientSearch";
import { Client } from "../../interfaces/ClientInterface";
import { showDOBAndGender } from "../Billing/PrintBill/EightyMmPrint/ClientInfo";

export const getClientGender = (genderValue: string): string => {
  if (genderValue === "1") return "Male";
  if (genderValue === "2") return "Female";
  return "Other";
};

interface AssessmentClientSelectProps {
  clientId: number;
  setClientId: React.Dispatch<React.SetStateAction<number>>;
  isDisabled: boolean;
  width?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function AssessmentClientSelect({
  clientId,
  setClientId,
  isDisabled,
  width
}: AssessmentClientSelectProps) {
  const client: Client = useSelector((state: RootState) =>
    state.clients.collection?.find((c: Client) => c.id === Number(clientId))
  );

  return (
    <Stack sx={{ width: width || "20rem" }}>
      <ClientSearch
        label={t("billing.client")}
        placeholder={t("selectClient")}
        error={!client}
        variant="outlined"
        margin="dense"
        client={client}
        autoFocus
        isDisabled={isDisabled}
        secondaryText={[
          {
            type: "customerNumber"
          },
          {
            type: "externalIdentifier",
            label: t("client.externalIdentifier.short")
          }
        ]}
        setClient={(selectedClient) => {
          if (selectedClient) setClientId(selectedClient.id);
        }}
      />
      {client && (
        <Typography fontSize="14px" component="span">
          {showDOBAndGender(client.gender, client.dob, true)}
          {client.phone && (client.dob || client.gender) ? `, ${client.phone}` : client.phone}
        </Typography>
      )}
    </Stack>
  );
}
